import { toast } from "@/v2-ui/toast"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useUserRevokeSessionsMutation } from "@/v2-backoffice-client/user/revokeSessions/user.revokeSessions.mutation"
import { USER_REVOKE_SESSIONS_DONE_TITLE } from "@/v2-backoffice-client/user/revokeSessions/user.revokeSessions.constants"

export type UserRevokeSessionsMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  userId: number
  confirmDescription?: string
  onCompleted?(): void
}

function UserRevokeSessionsMenuItem(props: UserRevokeSessionsMenuItemProps) {
  const { userId, confirmDescription, onCompleted, ...menuItemProps } = props

  const [revokeSessions, { loading, error }] = useUserRevokeSessionsMutation({
    onCompleted() {
      toast({ variant: "success", title: USER_REVOKE_SESSIONS_DONE_TITLE })
      onCompleted?.()
    },
  })

  return (
    <ActionMenu.ConfirmItem
      variant="warning"
      iconSrc="sign-out-alt"
      isLoading={loading}
      error={error}
      errorTitle="Failed to revoke sessions"
      confirmTitle="Revoke Sessions"
      confirmDescription={
        confirmDescription ??
        "Are you sure you want to revoke all sign-in sessions for this user?"
      }
      confirmText="Revoke Sessions"
      confirmVariant="warning"
      onConfirm={async () => {
        await revokeSessions({ variables: { id: userId } })
      }}
      {...menuItemProps}
    >
      Revoke Sessions
    </ActionMenu.ConfirmItem>
  )
}

export default UserRevokeSessionsMenuItem
